import React from 'react';
import ReactMarkdown from 'react-markdown';
import { styled } from 'themes';

const Markdown = props => {
  return <StyledMarkdown source={props.source} />;
};

const StyledMarkdown = styled(ReactMarkdown)`
  grid-column: center-start / center-end;
  margin-top: -5rem;
  margin-bottom: -5rem;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    max-width: 735px;
    line-height: 1.5;
    margin-bottom: 1rem;
  }

  h2 {
    font-size: 3.2rem;
  }

  p {
    font-size: 2rem;
    margin-bottom: 1.5rem;
  }

  li {
    list-style: none;
    font-size: 2rem;

    &:before {
      content: '· ';
    }
  }

  a:link,
  a:visited {
    color: ${({ theme }) => theme.colors.darkOrange};
    font-weight: 700;
    text-decoration: none;
  }

  img {
    width: 100%;
    height: auto;
    margin-top: 15px;
  }

  img + em {
    display: inherit;
    font-size: 90%;
  }
`;

export default Markdown;
